import { render, staticRenderFns } from "./login-swiper.vue?vue&type=template&id=5962d0e7&lang=true&"
import script from "./login-swiper.vue?vue&type=script&lang=js&"
export * from "./login-swiper.vue?vue&type=script&lang=js&"
import style0 from "./login-swiper.vue?vue&type=style&index=0&id=5962d0e7&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports